import { getAccessToken } from '../AuthToken';
import {
    TOGGLE_LEAD,
    IS_LOADING,
    GET_PERSON_BY_ID,
    USER_TICKETS_FETCHED,
    FETCH_SESSION_FOR_REGISTRATION_BY_TICKET,
    FETCH_SESSION_REGISTERED_BY_TICKET,
    USER_SELECT_TICKET,
    USER_UNSELECT_TICKET,
    TICKET_SELECTION_POP_ACTION,
    SHOW_LOGIN,
    SET_SESSION_FULL_REGISTRATION,
    SAVE_A_SEAT_REQUEST,
    SAVE_A_SEAT_REQUEST_END,
    SET_SESSION_OVERLAPPING_REGISTRATION
} from '../constants/ActionTypes';
import * as ApiUtils from '../views/reactViews/ApiUtil';
import pubSUb from '../PubSub';
import axios from 'axios';
import Cookie from 'js-cookie';
import config from 'config';
import _ from 'underscore';
import { delay } from '../utils/SupportUtils';
import {isBizzaboInternalWebsiteWhiteLabeled} from '@bizzabo/whitelabel-utils';
import { TICKET_ENTITY_VALIDATION_LOG } from '../constants/SnowplowConst';
import { personIdByTicketSelector } from '../selectors/UserProfilePageSelector';


function toggleLeadAction(personId) {
    return {
        type: TOGGLE_LEAD,
        personId
    };
}

function getPersonByIdAction(response, personId) {
    return {
        type: GET_PERSON_BY_ID,
        response,
        personId
    };
}

function loadingAction(isLoading) {
    return {
        type: IS_LOADING,
        isLoading: isLoading
    };
}

const fetchUserTicketAction = tickets => ({
    type: USER_TICKETS_FETCHED,
    tickets
});

const unselectTicketByUserAction = (ticketId, currSelectedTicketsIds) =>{
    const selectedTicketsIds = _.without(currSelectedTicketsIds, ticketId);
    return {type: USER_UNSELECT_TICKET, ticketId, selectedTicketsIds};
};

const selectTicketByUserAction = (ticketId, currSelectedTicketsIds) =>{
    const selectedTicketsIds = _.union(currSelectedTicketsIds, [ticketId]);
    return {type: USER_SELECT_TICKET, selectedTicketsIds};
};

const fetchSessionForRegisterAction = (sessions, ticketId) => ({
    type: FETCH_SESSION_FOR_REGISTRATION_BY_TICKET,
    sessions, ticketId
});

const fetchRegisteredSessionOnAction = (sessions, ticketId) => ({
    type: FETCH_SESSION_REGISTERED_BY_TICKET,
    sessions, ticketId
});

const saveASeatRequest = (sessionId, ticketId) => ({type: SAVE_A_SEAT_REQUEST, sessionId, ticketId});

const saveASeatRequestEnd = (sessionId, ticketId) => ({type: SAVE_A_SEAT_REQUEST_END, sessionId, ticketId});

const toggleSessionRegistrationStatusPerSession = (sessionId, toRegister, ticketId) =>
    async(dispatch, getState) => {
        const {
            eventReducer: { event: { id: eventId } },
            userProfilePageReducer: { selectedTicketsIds }
        } = getState();
        try {
            dispatch(saveASeatRequest(sessionId, ticketId));
            const response = await ApiUtils.toggleSessionRegistrationStatusPerSession({ eventId, sessionId, ticketId, toRegister });
            if (!toRegister) {
                dispatch(setSessionFullRegistration(false, sessionId));
            }

            dispatch(fetchRegisteredSessionOnAction(response, ticketId));
            await delay(2000);
            const sessionForRegister = await ApiUtils.getSessionForRegistrationByTicket(eventId, ticketId);
            dispatch(fetchSessionForRegisterAction(sessionForRegister, ticketId));
            return response;
        } catch (e) {
            if (selectedTicketsIds && selectedTicketsIds.length > 1 && e === 'capacity reached'|| e?.message === 'Session capacity reached'){
                setTimeout(() => dispatch(setSessionFullRegistration(true, sessionId)), 1500);
                throw e;
            } else if (e?.errorCode === 'session_registration_error' && e?.message === 'session overlapping between old and new selected sessions is not allowed') {
                setTimeout(() => dispatch(setSessionIsOverlapping(true, sessionId)), 1500);
                throw e;
            } else {
                throw e;
            }
        } finally {
            dispatch(saveASeatRequestEnd(sessionId, ticketId));
        }
    };

const setSessionFullRegistration = (isFullRegistration, sessionId) => ({type: SET_SESSION_FULL_REGISTRATION, isFullRegistration, sessionId});

const setSessionIsOverlapping = (isOverlapping, sessionId) => ({ type: SET_SESSION_OVERLAPPING_REGISTRATION, isOverlapping, sessionId });

const openCloseTicketSelectionPopUp = () => ({
    type: TICKET_SELECTION_POP_ACTION
});

const showEmailLogin = () => ({
    type: SHOW_LOGIN
});

function getPersonById(options = {}) {
    return (dispatch, getState) => {
        options.success = function(response) {
            dispatch(getPersonByIdAction(response, response.users[0].id));
            let options = {};
            let linkedInId = response.users && response.users[0] && response.users[0].linkedInId;
            options.linkedInId = linkedInId;
            options.person = response.users && response.users[0];
        };
        options.error = function(response) {
        };
        return ApiUtils.getPersonById(options);
    };
}


function loadingChanged(isLoading) {
    return (dispatch, getState) => dispatch(loadingAction(isLoading));
}

function toggleLead(options = {}) {
    return (dispatch, getState) => {
        dispatch(toggleLeadAction(options.personId));
        options.success = function() {
            let newStatus = !options.myLead;
            newStatus && pubSUb.publish('analytics:MarkedAsOpportunity', options.personId, options.fullName);
        };
        options.error = function() {
            dispatch(toggleLeadAction(options.personId));
        };
        return ApiUtils.toggleLead(options);
    };
}

function sendActivities(options = {}) {
    return (dispatch, getState) => ApiUtils.sendActivities(options);
}

const getUserTicketsByEvent = (eventId, shouldCheckSnowplowSession = false) =>
    async(dispatch, getState) => {
        let snowplowTools;
        try {
            const bizzaboToken = getAccessToken();
            if (window) {
                snowplowTools = await import('../utils/SnowplowUtils');
            }
            if (bizzaboToken) {
                const {
                    getSessionForRegistrationByTicket,
                    getRegisteredSessionByTicket,
                    getUserTickets
                } = ApiUtils;

                const result = await getUserTickets(eventId);
                // clear tickets data from un need data
                const tickets = result.map(({ formSubmission, ...rest }) => ({ ...rest }));

                dispatch(fetchUserTicketAction(tickets));

                const { selectedTicketsIds, personId } = personIdByTicketSelector(getState());

                if (snowplowTools) {
                    snowplowTools.addTicketToGlobalContext(tickets, shouldCheckSnowplowSession);
                    snowplowTools.startSPTicketTrack(shouldCheckSnowplowSession);
                }
                const storedEventId = localStorage.getItem('bz-selected-event');
                const storedTicketsIds = localStorage.getItem('bz-selected-ticket');
                const isTicketStored = storedEventId === eventId.toString() && storedTicketsIds;

                let selectedTicketsAction = {selectedTicketsIds};
                if (tickets && tickets.length > 0 || isTicketStored) {
                    const ticketsIds = tickets && tickets.map(({id}) => parseInt(id)) || [];
                    const cachedTicketsIds = (storedTicketsIds || '')
                        .split(',')
                        .map(id => parseInt(id))
                        .filter(id => ticketsIds.includes(id));
                    localStorage.setItem('bz-selected-ticket', cachedTicketsIds.toString());
                    const ticketsIdsByDefault = cachedTicketsIds.length ? cachedTicketsIds : ticketsIds;
                    let arrSessionForRegister = [], arrSessionRegisteredOn = [];
                    for (const ticketId of ticketsIdsByDefault) {
                        const [sessionForRegister = [], sessionRegisteredOn = []] = await Promise.all([
                            getSessionForRegistrationByTicket(eventId, ticketId),
                            getRegisteredSessionByTicket(eventId, ticketId, personId)
                        ]);
                        arrSessionForRegister.push(sessionForRegister);
                        arrSessionRegisteredOn.push(sessionRegisteredOn);
                    }
                    for (let i=0; i < ticketsIdsByDefault.length; i++) {
                        const ticketId = ticketsIdsByDefault[i];
                        dispatch(fetchSessionForRegisterAction(arrSessionForRegister[i], ticketId));
                        dispatch(fetchRegisteredSessionOnAction(arrSessionRegisteredOn[i], ticketId));
                        selectedTicketsAction = selectTicketByUserAction(ticketId, selectedTicketsAction.selectedTicketsIds);
                        dispatch(selectedTicketsAction);
                    }
                }
            } else {
                if (snowplowTools) {
                    snowplowTools.startSPTicketTrack(shouldCheckSnowplowSession);
                }
                return;
            }
        } catch (e) {
            if (snowplowTools) {
                const errorMessage = e?.message;
                if (typeof errorMessage === 'string' && errorMessage.includes('getUserTickets')) {
                    snowplowTools.sendSystemInfoEvent(TICKET_ENTITY_VALIDATION_LOG, errorMessage);
                }
            }
            throw e;
        }
    };

const selectTicketByUser = (ticketId, eventId) =>
    async(dispatch, getState) => {
        try {
            const {
                getSessionForRegistrationByTicket,
                getRegisteredSessionByTicket,
            } = ApiUtils;
            const {
                userProfilePageReducer: {selectedTicketsIds}
            } = getState();
            let action;
            if (selectedTicketsIds && !selectedTicketsIds.includes(ticketId)) {
                action = selectTicketByUserAction(ticketId, selectedTicketsIds);
                dispatch(action);

                localStorage.setItem('bz-selected-event', eventId);
                localStorage.setItem('bz-selected-ticket', action.selectedTicketsIds);

                const [sessionForRegister = [], sessionRegisteredOn = []] = await Promise.all([
                    getSessionForRegistrationByTicket(eventId, ticketId),
                    getRegisteredSessionByTicket(eventId, ticketId)
                ]);

                dispatch(fetchSessionForRegisterAction(sessionForRegister, ticketId));
                dispatch(fetchRegisteredSessionOnAction(sessionRegisteredOn, ticketId));
            } else {
                action = unselectTicketByUserAction(ticketId, selectedTicketsIds);
                dispatch(action);
                localStorage.setItem('bz-selected-event', eventId);
                localStorage.setItem('bz-selected-ticket', action.selectedTicketsIds);
            }
        } catch (e) {
            throw e;
        }
    };

const signedOutUserReact = (shouldShowLogin = false) =>
    async(dispatch, getState) => {
        try {
            const { eventReducer: { event } } = getState();
            const isWl = isBizzaboInternalWebsiteWhiteLabeled(event);
            const httpForRefreshToken = axios.create({ baseURL: '/' });
            const path = '/userProfile/oauth/logout';
            const url = isWl ? path : `${event['unique-name']}${path}`;
            await httpForRefreshToken({
                url,
                method: 'post'
            });
            Cookie.remove('x-bz-vote-id');
            Cookie.remove(config.previewCookieName, {
                domain: window.location.hostname
            });
            Cookie.remove('x-bz-vote-id');
            shouldShowLogin && dispatch(showEmailLogin());
        } catch (e) {
            throw e;
        }
    };

export {
    toggleLead,
    loadingChanged,
    getPersonById,
    sendActivities,
    toggleLeadAction,
    getPersonByIdAction,
    getUserTicketsByEvent,
    unselectTicketByUserAction,
    selectTicketByUser,
    signedOutUserReact,
    fetchUserTicketAction,
    selectTicketByUserAction,
    fetchSessionForRegisterAction,
    fetchRegisteredSessionOnAction,
    openCloseTicketSelectionPopUp,
    showEmailLogin,
    saveASeatRequest,
    saveASeatRequestEnd,
    toggleSessionRegistrationStatusPerSession,
    setSessionFullRegistration
};


